import React from 'react';
import { connect } from 'react-redux';

import classes from './Card.scss';

import maestroCardLogo from '../../../assets/images/payments/card/card-icons/maestro-logo.svg';
import masterCardLogo from '../../../assets/images/payments/card/card-icons/mastercard-logo.svg';
import amexLogo from '../../../assets/images/payments/card/card-icons/amex-logo.svg';
import dinersClubLogo from '../../../assets/images/payments/card/card-icons/diners-club-logo.svg';
import visaLogo from '../../../assets/images/payments/card/card-icons/visa-logo.svg';
import cardBackgroundImage from '../../../assets/images/payments/card/card-background-1.svg';

import { setAmountDetails } from '../../../store/actions/index';

const card = (props) => {

    if (props.cardType !== 'EMPTY') {
        if (props.creditCardPayment[props.cardType] === undefined) {
            return 
        } else {
            props.onSetAmountDetails(props.creditCardPayment[props.cardType]);
        }
    }

    return (
        <div style={{ perspective: '1000px' }}>
            <div className={[classes.Card, props.isCardFlipped ? classes.CardFlipped : null].join(' ')}>
                <div className={classes.CardBackgroundOne}><img src={cardBackgroundImage} alt='Card Background'/></div>
                <div className={classes.CardBackgroundTwo}><img src={cardBackgroundImage} alt='Card Background'/></div>
                <div className={classes.CardFront}>
                    <div className={classes.CardImage}>
                        {
                            props.cardType === 'VISA' ? <img src={visaLogo} alt='Card'/> :
                                props.cardType === 'MASTER' ? <img src={masterCardLogo} alt='Card'/> : 
                                    props.cardType === 'RUPAY' ? <img src={amexLogo} alt='Card'/> : 
                                        props.cardType === 'DINERS' ? <img src={dinersClubLogo} alt='Card'/> :  
                                            props.cardType === 'MAESTRO' ? <img src={maestroCardLogo} alt='Card'/> : 
                                                props.cardType === 'AMEX' ? <img src={amexLogo} alt='Card'/> : null
                        }
                    </div>
                    <div className={classes.CardNumber}>
                        {
                            props.creditCardValue === '' ? <div style={{ fontSize: '1.2rem' }}>
                            &#9679;
                            &#9679;
                            &#9679;
                            &#9679;
                            &nbsp;
                            &#9679;
                            &#9679;
                            &#9679;
                            &#9679;
                            &nbsp;
                            &#9679;
                            &#9679;
                            &#9679;
                            &#9679;
                            &nbsp;
                            &#9679;
                            &#9679;
                            &#9679;
                            &#9679;
                        </div> : <div>
                            {props.creditCardValue}
                        </div>
                        }
                    </div>
                    <div className={`u-flex justify-content-between`}>
                        <div className={classes.CardName}>
                            <p className={[classes.CardTextLight, props.nameValue !== '' ? classes.CardTextLightActive : null ].join(' ')}>Name</p>
                            { props.nameValue !== '' ? <p>{props.nameValue}</p> : null }
                        </div>
                        <div className={classes.CardDate}>
                            <p className={[classes.CardTextLight, props.expiryDateValue !== '' ? classes.CardTextLightActive : null ].join(' ')}>Date</p>
                            {props.expiryDateValue !== '' ? <p>{props.expiryDateValue}</p> : null}
                        </div>
                    </div>
                </div>
                <div className={classes.CardBack}>
                    <div className={classes.CardStripe}></div>
                    <div className={classes.CardSignature}><p>{props.cvvValue}</p></div>
                </div>
            </div>
        </div>
    );
}


const mapStateToProps = state => {
    return {
        isCardFlipped: state.payments.isCardFlipped,
        creditCardPayment: state.payments.bookingDetails.agentPaymentOptions.amountDetails.CC
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetAmountDetails: (val) => dispatch(setAmountDetails(val))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(card);


// WEBPACK FOOTER //
// ./src/components/Payment/Card/Card.js